import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IContributionType } from "src/models/HumanResources/ContributionTypes.models";

interface ContributionTypeState {
  contributionTypes: IContributionType[];
  contributionTypeToEdit: IContributionType | null;
}

const initialState: ContributionTypeState = {
  contributionTypes: [],
  contributionTypeToEdit: null,
};

const ContributionTypeSlice = createSlice({
  name: "ContributionType",
  initialState,
  reducers: {
    setContributionTypeList: (
      state,
      action: PayloadAction<IContributionType[]>
    ) => {
      state.contributionTypes = action.payload;
    },
    concatListContributionType: (
      state: ContributionTypeState,
      action: PayloadAction<IContributionType[]>
    ) => {
      state.contributionTypes = [
        ...state.contributionTypes.concat(action.payload),
      ];
    },
    setContributionTypeToEdit: (
      state,
      action: PayloadAction<IContributionType | null>
    ) => {
      state.contributionTypeToEdit = action.payload;
    },
    addContributionType: (state, action: PayloadAction<IContributionType>) => {
      state.contributionTypes.push(action.payload);
    },
    updateContributionType: (
      state,
      action: PayloadAction<IContributionType>
    ) => {
      let itemIndex = state.contributionTypes.findIndex(
        item => item.contributionTypeId === action.payload.contributionTypeId
      );
      if (itemIndex !== -1) state.contributionTypes[itemIndex] = action.payload;
    },
    deleteContributionType: (state, action: PayloadAction<number>) => {
      const newArray = state.contributionTypes.filter(
        item => item.contributionTypeId !== action.payload
      );
      state.contributionTypes = newArray;
    },
  },
});

export const {
  setContributionTypeList,
  concatListContributionType,
  setContributionTypeToEdit,
  addContributionType,
  updateContributionType,
  deleteContributionType,
} = ContributionTypeSlice.actions;

export default ContributionTypeSlice.reducer;
